import { emptyToolInputSchema } from "@phoenix/agent/tools/emptyToolInput";

export const runPlaygroundInputSchema = emptyToolInputSchema;
export const cancelPlaygroundRunInputSchema = emptyToolInputSchema;
